import { render, staticRenderFns } from "./fundDetailStatistics.vue?vue&type=template&id=254059e5&scoped=true"
import script from "./fundDetailStatistics.vue?vue&type=script&lang=js"
export * from "./fundDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./fundDetailStatistics.vue?vue&type=style&index=0&id=254059e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254059e5",
  null
  
)

export default component.exports